module.exports = __webpack_public_path__ + "static/media/2 compass sail ship nautical ocean sea.1280x1707.8b656e2a.webp";